import * as React from "react";
function SvgEyeCrossed(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <defs>
        <clipPath id="eye-crossed_svg__a">
          <path d="M0 0h28L0 28zm4 32h28V4z" fill="none" />
        </clipPath>
      </defs>
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M3 29L29 3"
      />
      <g
        clipPath="url(#eye-crossed_svg__a)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      >
        <path d="M31 17c-5 8-12 10-15 10S6 25 1 17C4 9 10 5 16 5s12 4 15 12z" />
        <path d="M16 10a6 6 0 00-2.37.49A3 3 0 1110 15.26 6 6 0 1016 10z" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgEyeCrossed);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
